import React, { useEffect, useState } from "react";
import CustomerSupportAside from "./CustomerSupportAside";
import axios from "axios";

function CustomerSupportChecklist() {
  const [checklistData, setChecklistData] = useState([
    {
      id: 1,
      text: "School Data Centralized",
      isChecked: false,
      locked: false
    },
    {
      id: 2,
      text: "Data Verification Completed",
      isChecked: false,
      locked: false,
    },
    {
      id: 3,
      text: "Management Accounts Created",
      isChecked: false,
      locked: false,
    },
    {
      id: 4,
      text: "Teacher Accounts Created",
      isChecked: false,
      locked: false,
    },
    {
      id: 5,
      text: "Parent Accounts Created",
      isChecked: false,
      locked: false
    },
    {
      id: 6,
      text: "Parent Accounts Verified",
      isChecked: false,
      locked: false,
    },
    {
      id: 7,
      text: "Accountant Account Created",
      isChecked: false,
      locked: false,
    },
    {
      id: 8,
      text: "Transport Manager Account Created",
      isChecked: false,
      locked: false,
    },
    {
      id: 9,
      text: "Driver Accounts Created",
      isChecked: false,
      locked: false
    },
    {
      id: 10,
      text: "Timetable Generated",
      isChecked: false,
      locked: false
    },
    {
      id: 11,
      text: "Timetable Verified",
      isChecked: false,
      locked: false
    },
    {
      id: 12,
      text: "Event Calendar Configured",
      isChecked: false,
      locked: false,
    },
    {
      id: 13,
      text: "Event Calendar Verified",
      isChecked: false,
      locked: false,
    },
    {
      id: 14,
      text: "Fee Types Configured",
      isChecked: false,
      locked: false
    },
    {
      id: 15,
      text: "Fees Added",
      isChecked: false,
      locked: false
    },
    {
      id: 16,
      text: "Discounts Added",
      isChecked: false,
      locked: false
    },
    {
      id: 17,
      text: "Attendance Settings Configured",
      isChecked: false,
      locked: false,
    },
    {
      id: 18,
      text: "Teacher Attendance Configured",
      isChecked: false,
      locked: false,
    },
    {
      id: 19,
      text: "Student Attendance Timings Configured",
      isChecked: false,
      locked: false,
    },
    {
      id: 20,
      text: "School Radius Configured",
      isChecked: false,
      locked: false,
    },
    {
      id: 21,
      text: "Transport Setup Completed",
      isChecked: false,
      locked: false,
    },
    {
      id: 22,
      text: "School Approval Recived",
      isChecked: false,
      locked: false,
    },
    {
      id: 23,
      text: "School Go-Live Completed",
      isChecked: false,
      locked: false,
    },
  ]);
  const [checklistDataSuccess, setChecklistDataSuccess] = useState(false);
  const [checklistDataFailure, setChecklistDataFailure] = useState(false);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);
  const [schoolDetails, setSchoolDetails] = useState([]);
  const [schoolDetailsLoading, setSchoolDetailsLoading] = useState(false);
  const [schoolDetailsError, setSchoolDetailsError] = useState("");
  const [isChecklistSubmitted, setIsChecklistSubmitted] = useState(false); // To track if the checklist has been submitted

  useEffect(() => {
    setSchoolDetailsLoading(true);

    axios
      .get("https://cleezoclass.com:8443/api/schools")
      .then((response) => {
        console.log(response.data);

        setSchoolDetails(response.data);
      })
      .catch((error) => {
        console.error(error);
        setSchoolDetailsError("Failed to load school details");
      })
      .finally(() => {
        setSchoolDetailsLoading(false);
      });
  }, []);

useEffect(() => {
  if (!selectedSchoolId) return;

  axios
    .get(`https://cleezoclass.com:8443/api/checklist/${selectedSchoolId}`)
    .then((response) => {
      // Support both a raw array response and a { checklist: [...] } response
      const rawChecklist = Array.isArray(response.data)
        ? response.data
        : response.data?.checklist;

      if (rawChecklist && rawChecklist.length > 0) {
        const loadedChecklist = rawChecklist.map((item) => ({
          ...item,
          locked: item.isChecked, // disable checkbox for anything already checked
        }));
        setChecklistData(loadedChecklist);
      } else {
        // No saved checklist yet for this school — reset to defaults
        setChecklistData((prev) =>
          prev.map((item) => ({ ...item, isChecked: false, locked: false }))
        );
      }
    })
    .catch((err) => console.log(err));
}, [selectedSchoolId]);

  const handleSubmit = async () => {
    try {
      setChecklistDataSuccess(false);
      setChecklistDataFailure(false);

      const updatedChecklist = checklistData.map((item) => ({
        ...item,
        locked: item.isChecked,
      }));

      const response = await axios.post(
        "https://cleezoclass.com:8443/api/checklist",
        {
          schoolId: selectedSchoolId,
          checklist: updatedChecklist,
        },
      );

      if (response.status === 200 || response.status === 201) {
        setChecklistData(updatedChecklist);
        setChecklistDataSuccess(true);
      }
    } catch (error) {
      console.error(error);
      setChecklistDataFailure(true);
    }
  };

  const handleCheckboxChange = (id) => {
    setChecklistData((prevData) =>
      prevData.map((item) => {
        if (item.id !== id) return item;

        if (item.locked) return item;

        return {
          ...item,
          isChecked: !item.isChecked,
        };
      }),
    );
  };

  return (
    <div className="mainBlock">
      <h2>Customer Support Exicutive</h2>
      <CustomerSupportAside />
      <div className="cust-spt-conatiner cust-checklist">
        <h1>CheckList</h1>

        <label>Select School Details :</label>
        <select
          className="cust-spt-checklist-select"
          value={selectedSchoolId || ""}
          onChange={(e) => setSelectedSchoolId(e.target.value)}
        >
          <option value="">Select School</option>

          {schoolDetails.map((school) => (
            <option key={school.id} value={school.id}>
              {school.institute_name}
            </option>
          ))}
        </select>

        {!selectedSchoolId && (
          <p className="select-school-message">
            Please select a school to view the onboarding checklist.
          </p>
        )}

        {selectedSchoolId && (
          <div className="cust-spt-checklist">
            <h1>Final Onboarding Checklit</h1>
            <div className="checklist-container">
              {checklistData.map((item) => (
                <div key={item.id} className="checklist-card">
                  <label className="checklist-item">
                    <input
                      type="checkbox"
                      checked={item.isChecked}
                      disabled={item.locked}
                      onChange={() => handleCheckboxChange(item.id)}
                    />
                    <span
                      style={{
                        color: item.locked ? "#888" : "#000",
                        fontWeight: item.locked ? "600" : "400",
                      }}
                    >
                      {item.text}
                    </span>
                  </label>
                </div>
              ))}
            </div>
            <div className="checklist-items-submitBtn">
              {checklistDataSuccess && (
                <p className="success-message">Checklist saved successfully.</p>
              )}

              {checklistDataFailure && (
                <p className="error-message">Failed to save checklist.</p>
              )}

              <button onClick={handleSubmit}>Submit</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomerSupportChecklist;
